import React from 'react';
import { Radio, RadioGroup } from '@tesla/informed-tds';
import { arrayOf, shape, string } from 'prop-types';
// import style from './style.module.scss';

const HorizontalRadioGroup = ({ options, ...props }) => (
  <RadioGroup {...props}>
    {options.map((option) => (
      <Radio key={option.value} {...option} />
    ))}
  </RadioGroup>
);

HorizontalRadioGroup.propTypes = {
  options: arrayOf(
    shape({
      const: string,
      title: string,
    })
  ).isRequired,
};

export default HorizontalRadioGroup;
